var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Default")]),_c('transition',{attrs:{"name":"bounce"}},[_c('child')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }